import { memo } from "react";
import { TextField, Box, FormControlLabel, Checkbox, MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FlexGrid, Typography, DefaultComponentProps } from "@albo-ui/core";
import { useGeneralConfirm } from "./hooks/useGeneralConfirm";

export type ConfirmDialogDialogProps = {
    onConfirm: (text?: string) => void;
    onClose: () => void;
    open: boolean;
    text: object;
    item?: string;
    element?: any;
    width?: any;
} & DefaultComponentProps;

const ItemConfirmDialog = ({ onConfirm, onClose, open, text, item, element, width }: ConfirmDialogDialogProps) => {
    const { onHandleChange, form, valid, adminName } = useGeneralConfirm(open, item);

    const validateType = (element) => {
        switch (element["type"]) {
            case "textField":
                return <FlexGrid key={element.key} style={{marginBottom: 10, marginTop: 30}}>
                    {element["text"] && <Box mb={2}><Typography variant="paragraph">{element.text}</Typography></Box>}
                    <TextField value={(form && form[element?.key]) || ""} type={element?.textType || "text"} onInput={onHandleChange.bind(this, element['key'], null)} color="secondary" label={element["label"]} fullWidth/>
                </FlexGrid>
            case "checkBox":
                return <FlexGrid key={element.key}>
                    {element["text"] && <Box mb={2}><Typography variant="paragraph">{element.text}</Typography></Box>}
                    {element["options"].map((c, i) => {
                        return <FormControlLabel key={i} control={<Checkbox checked={form ? form[element?.key] === c["value"] ? true : false : false} onChange={onHandleChange.bind(this, element['key'], c["value"])} color='secondary'/>} label={c['label']} />
                    })}
                </FlexGrid>
            case "select":
                return <FlexGrid key={element.key} style={{marginTop: 30}}> 
                <FormControl variant="standard" fullWidth required={true}>
                    <InputLabel sx={{left: 0, top: -20}}>{element["label"]}</InputLabel>
                    <Select value={(form && form[element?.key]) || -1} onChange={onHandleChange.bind(this, element['key'], null)} color="secondary" MenuProps={{style: {zIndex: 35001}}} sx={{mb: 2, width: "50%"}} inputProps={{ shrink: "true" }} variant="outlined">
                        <MenuItem value={-1} disabled>Seleccione</MenuItem>
                        {element["options"] && element["options"].map((opt) => (
                            <MenuItem key={`risk-${opt.key}`} value={opt.key}>
                                {opt.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                </FlexGrid>
            case "list":
                return <FlexGrid key={element.key} style={{marginTop: 30}}>
                    {element["text"] && <Box mb={1}><Typography variant="smallTitle">{element.text}:</Typography></Box>}
                    <Box display={"grid"}>
                        {element["list"].map((c, i) => {
                            return <Typography key={i} variant="paragraph">{c[element.key]}</Typography>
                        })}
                    </Box>
                </FlexGrid>
            case "items":
                return <FlexGrid key={element.key} style={{marginTop: 30}}>
                    {element["text"] && <Box mb={1}><Typography variant="smallTitle">{element.text}:</Typography></Box>}
                    <Box display={"grid"}>
                        {element["items"].map((i) => {
                            return <div key={i.key}>
                            <Typography variant="paragraph" color="lightNeutral" style={{paddingRight: 20}}>{i.name}:</Typography>
                            <Typography variant="paragraph">{i.label}</Typography>
                            </div>
                        })}
                    </Box>
                </FlexGrid>
            default:
                break;
        };
    };

    return (
        <Dialog onClose={onClose} open={open} style={{minWidth: width || "auto", maxHeight: 600}}>
            <DialogTitle>
                <Typography variant="h2">{text['title']}</Typography>
            </DialogTitle>
            
            <DialogContent>
                {text['message'] && <FlexGrid>
                    <Typography variant="paragraph">{text['message']}</Typography>
                </FlexGrid>}
                {adminName && <FlexGrid style={{marginTop: 20 }}>
                    <Typography variant="paragraph" bold>{adminName}</Typography>
                    <hr/>
                </FlexGrid>}
                {element && element.length > 0 &&
                    element.map((item) =>  validateType(item))
                }
            </DialogContent>

            <DialogActions>
                <FlexGrid container fullHeight fullWidth justify="space-between" alignItems="flex-end" style={{ marginTop: "20px", display: "flex" }}>
                    <FlexGrid item>
                        <Button onClick={onClose} buttonType="secondary" size="normal">
                            {text["cancelButton"] ? text["cancelButton"] : "Cancelar"}
                        </Button>
                    </FlexGrid>
                    <FlexGrid item>
                        <Button disabled={element && element[0]["type"] !== "list" && element[0]["type"] !== "items" ? !valid : false}  onClick={() => onConfirm(form)} size="normal">
                            {text["confirmButton"] ? text["confirmButton"] : "Aceptar"}
                        </Button>
                    </FlexGrid>
                </FlexGrid>
            </DialogActions>
        </Dialog>
    );
};

export default memo(ItemConfirmDialog);